module.exports = __webpack_public_path__ + "img/auPlat-on.18cee80f.svg";